<template>
  <v-card class="mx-auto" min-width="90%" max-width="344" color="#1F7087" dark>
    <v-card-text class="white--text">
      <div class="headline mb-2">{{category.name}}</div>
      {{category.is_credit}}
      <span v-if="category.notes">"{{category.notes}}"</span>
    </v-card-text>
    <v-card-actions>
      <v-btn text>Detail</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: {
    category: Object
  }
}
</script>
